// Pickup flow: location + day selection modals. Cart state goes through window.PickupSelection.
// Entry points (window.PickupModals): openNeededPickupModals (add-to-cart / change day),
// openPickupModals (banner/header), editPreferredLocation (account preferred location).

(function () {
  const LOCATION_MODAL_ID = 'pickup-location-modal';
  const DAY_MODAL_ID = 'pickup-day-modal';
  const SKELETON_ROW_COUNT = 4;
  const MAX_SPOTS_COUNT_SHOWN = 10;

  // Store callback to run once the add to cart flow finishes such as add item to cart (Called on day modal submit).
  let onComplete = null;
  //Function to run once a location is selected (changes for add to cart vs setting preferred location).
  let onLocationSelected = null;

  function showModal(id) {
    const modal = document.getElementById(id);
    if (modal) modal.classList.add('is-open');
  }

  function hideModal(id) {
    const modal = document.getElementById(id);
    if (modal) modal.classList.remove('is-open');
  }

  // Open the day step if a location is known, else pick a location first.
  // Optional onDone runs after the day is set (used by deferredadd to cart)
  function openNeededPickupModals({ onDone } = {}) {
    onComplete = typeof onDone === 'function' ? onDone : null;

    let selectedLocation = window.PickupSelection.get().handle;
    if (!selectedLocation) {
      const prefs = (window.PickupContext && window.PickupContext.preferredPickupLocations) || [];
      selectedLocation = prefs[0] || null;
    }

    if (selectedLocation && getLocationName(selectedLocation)) {
      writeLocationToCart(selectedLocation);
      openDayModal();
    }
    // No location selected and no preferred location saved
    else {
      openLocationModal({ onSelect: orderFlowSubmit });
    }
  }

  // Banner flow: User clicked the pickup banner/header to select pickup location/day
  function openPickupModals() {
    onComplete = null;
    openLocationModal({ onSelect: orderFlowSubmit });
  }

  // Edit button in the day modal: go back to the location step, keeping any pending add-to-cart.
  function editLocation() {
    closeDayModal();
    openLocationModal({ onSelect: orderFlowSubmit });
  }

  // Account flow: User editing their preferred pickup location.
  function editPreferredLocation() {
    onComplete = null;
    openLocationModal({ onSelect: savePreferredLocation });
  }

  // User dismissed the flow (X / Cancel / overlay) — drop any pending completion and close.
  function cancel() {
    onComplete = null;
    closeLocationModal();
    closeDayModal();
  }

  //#region Location modal

  // Get location display name from the the modal's radio button
  function getLocationName(handle) {
    if (!handle) return '';
    const input = document.querySelector(`#${LOCATION_MODAL_ID} input[value="${CSS.escape(handle)}"]`);
    return input ? input.dataset.name : '';
  }

  function getLocationAddress(handle) {
    if (!handle) return '';
    const input = document.querySelector(`#${LOCATION_MODAL_ID} input[value="${CSS.escape(handle)}"]`);
    return (input && input.dataset.address) || '';
  }

  // Write a location to the cart unless it's already the current selection.
  function writeLocationToCart(handle) {
    if (window.PickupSelection.get().handle === handle) return;
    const name = getLocationName(handle);
    if (!name) return;
    window.PickupSelection.setLocation({ handle, locationName: name }).catch((err) =>
      console.error('PickupModals: failed to write location to cart', err)
    );
  }

  function openLocationModal({ onSelect } = {}) {
    if (typeof onSelect === 'function') onLocationSelected = onSelect;
    preselectLocation();
    showModal(LOCATION_MODAL_ID);
  }

  function closeLocationModal() {
    hideModal(LOCATION_MODAL_ID);
  }

  // Check the radio matching the current selection so reopening reflects prior choice.
  function preselectLocation() {
    const handle = window.PickupSelection.get().handle;
    document.querySelectorAll(`#${LOCATION_MODAL_ID} input[name="pickup_location"]`).forEach((radio) => {
      radio.checked = handle != null && radio.value === handle;
    });
  }

  function onLocationModalSubmit() {
    const selected = document.querySelector(`#${LOCATION_MODAL_ID} input[name="pickup_location"]:checked`);
    if (!selected) return;
    closeLocationModal();
    if (typeof onLocationSelected === 'function') onLocationSelected(selected.value, selected.dataset.name);
  }

  // Order flow: save the location to the cart, then move on to day selection.
  function orderFlowSubmit(handle, name) {
    window.PickupSelection.setLocation({ handle, locationName: name }).catch((err) =>
      console.error('PickupModals: failed to write location to cart', err)
    );
    openDayModal();
  }

  // Account flow: save the customer's preferred location, then refresh the page.
  function savePreferredLocation(handle) {
    const customerId = window.PickupContext && window.PickupContext.customerId;
    if (!customerId) return;
    window.PickupUserPreferences.updatePreferredPickupLocation(handle)
      .then(() => window.location.reload())
      .catch((err) => console.error('PickupModals: failed to save preferred location', err));
  }

  //#endregion

  //#region Day modal
  async function openDayModal() {
    const pickup = window.PickupSelection.get();

    const locationLabel = document.getElementById('pickup-day-selected-location');
    if (locationLabel) locationLabel.textContent = pickup.locationName || '';

    const addressEl = document.getElementById('pickup-day-selected-address');
    if (addressEl) addressEl.textContent = getLocationAddress(pickup.handle);

    showModal(DAY_MODAL_ID);
    renderLoading();

    try {
      const days = await loadDaysForLocation(pickup.handle);
      renderDays(days);
      preselectDay();
    } catch (err) {
      console.error('PickupModals: failed to load pickup days', err);
      renderMessage('Could not load pickup days. Please try again.');
    }
  }

  function closeDayModal() {
    hideModal(DAY_MODAL_ID);
  }

  // Resolved pickup days (with availability) for a location, from the location schedule endpoint.
  async function loadDaysForLocation(handle) {
    const apiUrl = KROWN.settings.api_urls.cubbie_availability_app_url;
    const response = await fetch(`${apiUrl}/locations/${encodeURIComponent(handle)}/schedule`);
    if (!response.ok) throw new Error(`Schedule request failed: ${response.status}`);
    const data = await response.json();
    return data.days || [];
  }

  // Replace the day list with a single status line (empty / error).
  function renderMessage(text) {
    const list = document.getElementById('pickup-day-list');
    if (!list) return;
    list.replaceChildren();
    const message = document.createElement('p');
    message.className = 'pickup-modal__message';
    message.textContent = text;
    list.append(message);
  }

  // While days load, clone invisible placeholder rows to reserve the height of real rows
  // (so the panel doesn't jump), and show "Loading" centered over that reserved space.
  function renderLoading() {
    const list = document.getElementById('pickup-day-list');
    const template = document.getElementById('pickup-day-skeleton');
    if (!list || !template) return;
    list.replaceChildren();
    for (let i = 0; i < SKELETON_ROW_COUNT; i++) {
      list.append(template.content.cloneNode(true));
    }
    const loading = document.createElement('p');
    loading.className = 'pickup-modal__loading';
    loading.textContent = 'Loading pickup days…';
    list.append(loading);
  }

  function spotsAvailableText(availableCubbies) {
    if (availableCubbies > MAX_SPOTS_COUNT_SHOWN) return 'Spots available';
    return `${availableCubbies} spot${window.pluralS(availableCubbies)} available`;
  }

  function renderDays(days) {
    const list = document.getElementById('pickup-day-list');
    const template = document.getElementById('pickup-day-option');
    if (!list || !template) return;

    if (!days.length) {
      renderMessage('No pickup days available.');
      return;
    }

    //clear the list to remove stale days
    list.replaceChildren();

    for (const day of days) {
      const isFull = day.maxBoxesForOrder === 0;
      const row = template.content.cloneNode(true);

      const radio = row.querySelector('input[type="radio"]');
      radio.value = day.date;
      radio.disabled = isFull;

      row.querySelector('[data-day-title]').textContent = window.DateUtils.formatLong(day.date);
      row.querySelector('[data-day-status]').textContent = isFull ? 'Full' : spotsAvailableText(day.availableCubbies);

      list.append(row);
    }
  }

  // Check the radio matching the currently selected day (if still offered and available).
  function preselectDay() {
    const day = window.PickupSelection.get().day;
    if (!day) return;
    const radio = document.querySelector(`#${DAY_MODAL_ID} input[value="${CSS.escape(day)}"]`);
    if (radio && !radio.disabled) radio.checked = true;
  }

  function onDayModalSubmit() {
    const selected = document.querySelector(`#${DAY_MODAL_ID} input[name="pickup_day"]:checked`);
    if (!selected) return;

    window.PickupSelection.setDay(selected.value)
      .then(() => {
        closeDayModal();
        if (onComplete) {
          const done = onComplete;
          onComplete = null;
          done();
        }
      })
      .catch((err) => {
        console.error('PickupModals: failed to write day to cart', err);
        closeDayModal();
      });
  }

  //#endregion

  // Dismiss the flow via Escape or a clicking outside the modal.
  function initDismiss() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && document.querySelector('.pickup-modal.is-open')) cancel();
    });
    [LOCATION_MODAL_ID, DAY_MODAL_ID].forEach((id) => {
      const modalOverlay = document.getElementById(id);
      if (modalOverlay) {
        modalOverlay.addEventListener('click', (event) => {
          if (event.target === modalOverlay) cancel();
        });
      }
    });
  }
  initDismiss();

  window.PickupModals = {
    openNeededPickupModals,
    openPickupModals,
    editPreferredLocation,
    editLocation,
    onLocationModalSubmit,
    onDayModalSubmit,
    cancel,
    getLocationName,
    getLocationAddress,
  };
})();
